import MobileDatePicker from './MobileDatePicker';
import DesktopDatePicker from './DesktopDatePicker';
import moment, { type Moment } from 'moment';
import isTouchDevice from '@/lib/utils/isTouchDevice';

export type DatePickerProps = {
  value: Moment;
  onChange: (value: Moment) => void;
  onSave: (value: Moment) => void;
  shouldDisableDate?: (date: Moment) => boolean;
  clearable?: boolean;
  disabled?: boolean;
};

const EMPTY_MOMENT_VALUE = moment(null);

const DatePicker = (props: DatePickerProps) => {
  const handleClear = (): void => {
    if (!props.clearable) {
      return;
    }

    props.onChange(EMPTY_MOMENT_VALUE);
    props.onSave(EMPTY_MOMENT_VALUE);
  };

  if (isTouchDevice()) {
    return <MobileDatePicker onClear={handleClear} {...props} />;
  }

  return <DesktopDatePicker onClear={handleClear} {...props} />;
};

export default DatePicker;
